import type { FC } from "react";
import { Link, useNavigate } from "react-router-dom";

import { getRouteVacancy } from "../../../../shared/constants/routes";
import { classNames } from "../../../../shared/lib/classNames";

import styles from "./VacancyItem.module.scss";

import { IconButton } from "../../../../shared/ui";
import { MediaQueryProperty, MediaSizeEnum } from "../../../../shared/constants/media";
import { useMediaQuery } from "../../../../shared/hooks/useMediaQuery";
import { VacancyTabs } from "../VacancyTabs";

interface VacancyItemProps {
    className?: string;
    vacancyItem: any;
}

export const VacancyItem: FC<VacancyItemProps> = ({ className, vacancyItem }) => {
    const isMobile = useMediaQuery(`(max-width: 585px)`);
    const isTablet = useMediaQuery(
        `(${MediaQueryProperty.MinWidth}: ${MediaSizeEnum.sm}) and (${MediaQueryProperty.MaxWidth}: ${MediaSizeEnum.lg})`,
    );

    const navigate = useNavigate();

    const handleBack = () => navigate(getRouteVacancy(vacancyItem.id!));

    return (
        <Link
            to={getRouteVacancy(vacancyItem.id)}
            className={classNames({
                cls: styles.vacancy,
                additional: [className],
            })}
        >
            <div className={styles.vacancyAbout}>
                <p className={styles.vacancyAbout__title}>{vacancyItem.name}</p>
                <div className={styles.vacancyAbout__rightDescriptionColumn}>
                    <div className={styles.vacancyAbout__descriptionWrapper}>
                        <p>{vacancyItem.keyPhrase}</p>
                        {!isMobile && (
                            <IconButton
                                icon="rightTop"
                                theme="dark"
                                text={isTablet ? undefined : "Подробнее"}
                                textPosition="left"
                                onClick={handleBack}
                                className={styles.vacancyAbout__link}
                            />
                        )}
                    </div>
                    {!isTablet && <VacancyTabs vacancy={vacancyItem} isVisible={true} />}
                </div>
            </div>
            {isTablet && <VacancyTabs vacancy={vacancyItem} />}
        </Link>
    );
};
